import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8 px-4">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h3 className="text-xl font-bold mb-4 text-red-500">FIGHT GEAR</h3>
          <p className="mb-4 text-gray-300">Premium fighting equipment and training gear for champions. Your one-stop shop for all combat sports needs.</p>
          <div className="flex space-x-4">
            <a href="#social" aria-disabled="true" onClick={event => event.preventDefault()} className="text-gray-400 hover:text-white transition-colors duration-300">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="#social" aria-disabled="true" onClick={event => event.preventDefault()} className="text-gray-400 hover:text-white transition-colors duration-300">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#social" aria-disabled="true" onClick={event => event.preventDefault()} className="text-gray-400 hover:text-white transition-colors duration-300">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
        <div>
          <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2">
            <li>
              <Link to="/" className="text-gray-400 hover:text-white transition-colors duration-300">
                Home
              </Link>
            </li>
            <li>
              <Link to="/products" className="text-gray-400 hover:text-white transition-colors duration-300">
                Products
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-gray-400 hover:text-white transition-colors duration-300">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/contact" className="text-gray-400 hover:text-white transition-colors duration-300">
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-lg font-semibold mb-4">Store Information</h4>
          <ul className="space-y-3 text-gray-300">
            <li className="flex items-start">
              <span className="mr-2">🕒</span>
              <div>
                <p className="font-medium">Opening Hours</p>
                <p className="text-sm">24 hours</p>
              </div>
            </li>
            <li className="flex items-start">
              <span className="mr-2">🚚</span>
              <div>
                <p className="font-medium">Free Shipping</p>
                <p className="text-sm">On orders over QAR 10000</p>
              </div>
            </li>
            <li className="flex items-start">
              <span className="mr-2">↩️</span>
              <div>
                <p className="font-medium">Easy Returns</p>
                <p className="text-sm">15-day return policy</p>
              </div>
            </li>
            <li className="flex items-start">
              <span className="mr-2">🔒</span>
              <div>
                <p className="font-medium">Secure Payment</p>
                <p className="text-sm">100% secure checkout</p>
              </div>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
          <address className="not-italic text-gray-300">
            <div className="flex items-start mb-3">
              <span className="mr-2">📍</span>
              <div>
                <p className="font-medium">XFactor Sports Center</p>
                <p className="text-sm">Al Muftah Plaza Building, Bin Mahmoud</p>
                <p className="text-sm">Doha, Qatar</p>
              </div>
            </div>
            <div className="flex items-center mb-2">
              <span className="mr-2">📧</span>
              <a href="mailto:info@fightgear.com" className="hover:text-white transition-colors duration-300">
                info@fightgear.com
              </a>
            </div>
            <div className="flex items-center">
              <span className="mr-2">📞</span>
              <a href="https://wa.me/97431282831" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-300">
                +974 3128 2831
              </a>
            </div>
          </address>
        </div>
      </div>
      <div className="border-t border-gray-700 mt-8 pt-6 text-center text-gray-400">
        <p>&copy; {new Date().getFullYear()} Fight Gear. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
